import React from "react";
import { REGIMES_ACCOMPAGNEMENT } from "./libellesOperateur";

// Cartes à cocher des régimes d'accompagnement (maquette 10), partagées entre
// la modale de création et l'onglet Informations de la fiche.
const CartesRegimes = ({ name = "regimes", regimes = [], onBasculer, erreur = null, idPrefix = "" }) => (
  <>
    <div className="choix-regimes">
      {Object.entries(REGIMES_ACCOMPAGNEMENT).map(([id, regime]) => (
        <label
          key={id}
          className={`choix-carte choix-regime${regimes.includes(id) ? " is-checked" : ""}`}
        >
          <input
            type="checkbox"
            name={name}
            id={`${idPrefix}${name}-${id}`}
            value={id}
            checked={regimes.includes(id)}
            onChange={() => onBasculer(id)}
          />
          <span>
            <span className="choix-regime__titre">{regime.titre}</span>
            <span className="choix-regime__description">{regime.description}</span>
            <ul className="choix-regime__points">
              {regime.points.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
          </span>
        </label>
      ))}
    </div>
    {erreur && (
      <small role="alert" className="form-text text-danger">
        {erreur}
      </small>
    )}
  </>
);

export default CartesRegimes;
